export const common = {
    namespaced: true,
    state: {
        commonSearch: null,
        documentsSearch: localStorage.getItem('documents-search')
    },
    getters: {
        commonSearch: state => state.commonSearch,
    },
    mutations: {
        storeCommonSearch(state, search) {
            state.commonSearch = search;
        },
        documentsSearchUpdate(state, search) {
            state.documentsSearch = search.searchTerm;
            localStorage.setItem('documents-search', search.searchTerm ? search.searchTerm : '');
        }
    }
}
